import styled from 'styled-components';
import CSS from 'csstype';

import {
  convertToPixel,
  generateBorderProps,
  generateLayoutProps,
  generateSpaceProps,
} from './utils';
import { BorderProps, LayoutProps, SpaceProps } from './types';

interface FlexProps extends SpaceProps, LayoutProps, BorderProps {
  align?: CSS.Property.AlignItems;
  justify?: CSS.Property.JustifyContent;
  direction?: CSS.Property.FlexDirection;
  wrap?: CSS.Property.FlexWrap;
  gap?: CSS.Property.Gap | number;
  flex?: number;
}

export const Flex = styled.div<FlexProps>((props) => ({
  display: 'flex',
  flex: props.flex,
  alignItems: props.align,
  justifyContent: props.justify,
  flexDirection: props.direction,
  flexWrap: props.wrap,
  gap: props.gap && convertToPixel(props.gap),
  ...generateSpaceProps(props),
  ...generateLayoutProps(props),
  ...generateBorderProps(props),
}));
